import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const initialState = {
  articlesList:[{
    altText: '',
    contents: '',
    createdAt: '',
    id: 1,
    image: '',
    slug: '',
    summary: '',
    thumbnail: '',
    title: '',
    updatedAt: '',
  }]
}
function articles(state = initialState, action) {
  switch (action.type) {
    case types.ARTICLES_FETCH_SUCCESS:
        return assign({}, state, {
          articlesList: action.res,
        });
    case types.ARTICLE_FETCH_SUCCESS:
      console.log('ACTION RES', action.res)
    case types.ARTICLE_EDIT_SUCCESS:
      return assign({}, state, {
        article: action.res,
      });
    case types.ARTICLE_DELETE_SUCCESS:
        return assign({}, state, {
          articleDelete: action.res.ok,
        });  
    case types.ARTICLE_SET_ERROR:
    case types.ARTICLE_EDIT_ERROR:
    case types.ARTICLE_FETCH_ERROR:
    case types.ARTICLES_FETCH_ERROR:
    case types.ARTICLE_DELETE_ERROR:
        return assign({}, state, {
          error: action.res,
        });
    case types.ARTICLE_SET_SUCCESS:
        return assign({}, state, action.res)
    case types.ARTICLE_CLEAR_ERRORS:
        return assign({}, state, {
          error: false,
        });
    default:
    return state;
  }
}

export default articles


// WEBPACK FOOTER //
// ./src/reducers/articles.js